import React, { memo, Component } from 'react';
import Colors from 'components/Colors.js';

const colors = new Colors();

export const getVisualization = (event, subSequence, duration, width, useTranspose=false) => {
    return (
        <Visualization
          event={event}
          subSequence={subSequence}
          duration={duration}
          width={width}
          useTranspose={useTranspose}/>
   );
};

export const Visualization =  memo(({event, subSequence, duration, width, useTranspose=false}) => {
    if (event.patternNumber === undefined) {
        return '';
    }
    return (
        <div className="pattern-visualization">
          {subSequence.tracks.slice(0, 13).map(
              (x, i) =>
                  <TrackVisualization
                    useTranspose={useTranspose}
                    key={i}
                    track={x}
                    patternNumber={event.patternNumber}
                    stepWidth={width}
                    duration={duration}
                    step={event.step}/>)}
        </div>);
});

export const TrackVisualization = memo(({isSelected, track, patternNumber, duration, step=0, stepWidth, useTranspose}) => {
    let pattern = track.patterns[patternNumber % track.patterns.length];
    let start = step % pattern.length();
    let list = [];
    for (let _step in pattern.stepBucketsMatrix) {
        _step = parseInt(_step);
        let stepOffset = _step - start;
        let stepData = pattern.stepBucketsMatrix[_step].getAllOnSteps()[0];
        let count=0;
        for (let stepOffset=_step - start; stepOffset < duration; stepOffset += pattern.length()) {
            if (stepOffset < 0) {
                continue;
            }
            let style = {
                left: stepWidth * stepOffset,
                top: track.trackNumber * 3,
                width: stepWidth * 2 * stepData.duration,
                backgroundColor: colors.getColorForTrack(track),
                height: 2
            };
            if (count > 0) {
                style.opacity = 0.3;
            }
            if (useTranspose) {
                style.top = 20 + stepData.transpose * 0.5;
            }
            list.push(
                <div
                  key={stepOffset}
                  style={style}
                  className="track-step">
                </div>
            );
            count++;
        }
    }

    return (
        <div className={isSelected ? "selected track-steps" : "track-steps"}>
          {list}
        </div>);
});

export default Visualization;
